import React, { useState, useEffect } from "react";
import { useTable, usePagination } from "react-table";
import useApp from "../context/AppContext";
import { useNavigate } from "react-router-dom";
import { api, apiBlob } from "../utils/api";
import { FaBan, FaExternalLinkAlt, FaFileInvoiceDollar, FaGlasses, FaTrash, FaFileSignature } from "react-icons/fa";

const TabelaDocumentos = (props) => {
  const linExterno = require("../images/fotos/link_externo.png");
  const { usuario, setUsuario, setFatura, setLoading, showModalError, showModalMessage, showModalAnexo } = useApp();
  const navigate = useNavigate();
  const columns = React.useMemo(
    () => [
      {
        Header: "Name",
        isVisible: false,
        hideHeader: true,
        columns: [
          {
            Header: "ID",
            accessor: "idNota",
            style: "column1",
          },
          {
            Header: "Nº da Nota",
            accessor: "numeroNota",
            style: "column2",
          },
          {
            Header: "Data",
            accessor: "dataInclusaoStr",
            style: "column3",
          },
          {
            Header: "Descrição do Serviço",
            accessor: "descricao",
            style: "column4",
          },
          {
            Header: "Tipo",
            accessor: "tipo",
            style: "column5",
          },
          {
            Header: "Status",
            accessor: "statusFornecedor",
            style: "column6",
          },
        ],
      },
    ],
    []
  );
  const [order, setOrder] = useState("idNota");
  const [orderAsc, setOrderAsc] = useState(false);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {}, [usuario]);

  const Table = ({ columns, data }) => {

    // Use the state and functions returned from useTable to build your UI
    const {
      getTableProps,
      getTableBodyProps,
      headerGroups,
      prepareRow,
      page, // Instead of using 'rows', we'll use page,
      // which has only the rows for the active page

      // The rest of these things are super handy, too ;)
      canPreviousPage,
      canNextPage,
      pageOptions,
      //pageCount,
      gotoPage,
      nextPage,
      previousPage,
      //setPageSize,
      rows,
      state: { pageIndex, pageSize },
    } = useTable(
      {
        columns,
        data,
        initialState: { pageIndex: 0 },
      },
      usePagination
    );
    const handleDownloadNota = (id) => {
      setLoading(true);
      apiBlob(usuario)
        .get("/notasServico/abrirAnexo/" + id.toString(), {})
        .then((resp) => {
          //VISUALIZAR ARQUIVO
          const file = new Blob([resp.data], { type: "application/pdf" });
          let fileURL = URL.createObjectURL(file);
          window.open(fileURL, "_blank");
          //BAIXAR ARQUIVO
          //const content = resp.headers['content-type'];
          //download(resp.data, "Nota Fiscal " + id.toString(), content)
          setLoading(false);
        })
        .catch(function (error) {
          setLoading(false);
          if (error.response?.status === 406) {
            localStorage.clear();
            navigate("/login");
          } else showModalError("Erro ao acessar servidor");
        });
    };
    const handleDownloadBoleto = (id) => {
      setLoading(true);
      apiBlob(usuario)
        .get("/notasServico/abrirBoleto/" + id.toString(), {})
        .then((resp) => {
          //VISUALIZAR ARQUIVO
          const file = new Blob([resp.data], { type: "application/pdf" });
          let fileURL = URL.createObjectURL(file);
          window.open(fileURL, "_blank");
          setLoading(false);
        })
        .catch(function (error) {
          setLoading(false);
          if (error.response?.status === 406) {
            localStorage.clear();
            navigate("/login");
          } else showModalError("Erro ao acessar servidor");
        });
    };
    const handleDownloadCarta = (id) => {
      setLoading(true);
      apiBlob(usuario)
        .get("/notasServico/abrirCarta/" + id.toString(), {})
        .then((resp) => {
          //VISUALIZAR ARQUIVO
          const file = new Blob([resp.data], { type: "application/pdf" });
          let fileURL = URL.createObjectURL(file);
          window.open(fileURL, "_blank");
          setLoading(false);
        })
        .catch(function (error) {
          setLoading(false);
          if (error.response?.status === 406) {
            localStorage.clear();
            navigate("/login");
          } else showModalError("Erro ao acessar servidor");
        });
    };
    const handleCancelarNota = (id) => {
      if (!window.confirm("Deseja mesmo cancelar a nota?")) return;
      setLoading(true);
      api(usuario)
        .post("/notasServico/cancelar/" + id.toString())
        .then((resp) => {
          showModalMessage("Cancelamento", <h2>Nota cancelada com sucesso.</h2>);
          setUsuario({...usuario,documentos: []})
          setLoading(false);
          navigate("/listarDocumentos")
          document.location.reload(true);
        })
        .catch(function (error) {
          setLoading(false);
          if (error.response?.status === 406) {
            localStorage.clear();
            navigate("/login");
          } else showModalError("Erro ao acessar servidor");
        });
    };
    const PageButton = (props) => {
      return (
        <li className={`page-item ${pageIndex + 1 === props.pagina ? "active" : ""}`}>
          <button className="page-link" onClick={() => gotoPage(props.pagina - 1)}>
            {props.pagina}
          </button>
        </li>
      );
    };
    const PointsButton = () => {
      return (
        <li className="page-item disabled">
          <button className="page-link">...</button>
        </li>
      );
    };
    const Paginator = () => {
      const paginas = pageOptions.length;
      const paginaAtual = pageIndex + 1;
      return (
        <>
          <li className={`page-item ${!canPreviousPage ? "disabled" : ""}`}>
            <button className="page-link" onClick={() => previousPage()}>
              Anterior
            </button>
          </li>
          <PageButton pagina={1} />
          {paginaAtual >= 5 && <PointsButton />}
          {paginaAtual <= 4 && (
            <>
              {paginas >= 2 && <PageButton pagina={2} />}
              {paginas >= 3 && <PageButton pagina={3} />}
              {paginas >= 4 && <PageButton pagina={4} />}
              {paginas >= 5 && <PageButton pagina={5} />}
            </>
          )}
          {paginaAtual >= 5 && (
            <>
              <PageButton pagina={paginaAtual - 1} />
              <PageButton pagina={paginaAtual} />
              {paginaAtual < paginas && <PageButton pagina={paginaAtual + 1} />}
            </>
          )}
          {paginas >= 6 && paginaAtual + 3 <= paginas && <PointsButton />}
          {paginas >= 6 && paginaAtual < paginas - 1 && <PageButton pagina={paginas} />}
          <li className={`page-item ${!canNextPage ? "disabled" : ""}`}>
            <button className="page-link" onClick={() => nextPage()}>
              Próxima
            </button>
          </li>
        </>
      );
    };
    return (
      <>
        <div className="wrap-table100">
          <div className="table100 ver1 m-b-20">
            <table {...getTableProps()} className="table table-striped">
              <thead>
                {headerGroups.map((headerGroup) => (
                  <tr {...headerGroup.getHeaderGroupProps()} className="row100 head">
                    {headerGroup.headers.map((column) => {
                      let orderField;
                      switch (column.id) {
                        case "dataInclusaoStr":
                          orderField = "dataInclusaoMilis";
                          break;
                        default:
                          orderField = column.id;
                      }
                      let tdClass = orderField === order ? (orderAsc ? "seta-baixo" : "seta-cima") : "";
                      const onClickTh = () => {
                        if (orderField === order) {
                          setOrderAsc(!orderAsc);
                        } else {
                          setOrder(orderField);
                        }
                      };
                      return column.hideHeader === true ? null : (
                        <th
                          {...column.getHeaderProps()}
                          className={`column100 ${column.style} ${tdClass}`}
                          onClick={onClickTh}
                          key={column.id}
                        >
                          <span>{column.render("Header")}</span>
                        </th>
                      );
                    })}
                    {headerGroup.headers
                      .filter((column) => column.id === "idNota")
                      .map((column) => (
                        <th {...column.getHeaderProps()} className={`column100 column7`} key={column.id}>
                          <span>DETALHAMENTO</span>
                        </th>
                      ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {page.map((row) => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()} className="row100" key={row.id}>
                      {row.cells.map((cell, i) => {
                        let classStatus;
                        switch (cell.row.values.statusFornecedor) {
                          case "Em análise":
                            classStatus = "status_paga";
                            break;
                          case "Reprovado":
                            classStatus = "status_cancelada";
                            break;
                          case "Nova":
                            classStatus = "status_nova";
                            break;
                          default:
                            classStatus = "status_aprovado";
                        }
                        return (
                          <td
                            {...cell.getCellProps()}
                            className={"column100 " + cell.column.style}
                            data-label={`${cell.column.Header}: `}
                            key={"cell" + row.id + "-" + i}
                          >
                            <span className={cell.column.id === "status" ? classStatus : ""}>{cell.render("Cell")}</span>
                          </td>
                        );
                      })}
                      {row.cells
                        .filter((cell) => cell.column.id === "idNota")
                        .map((cell) => {
                          const fatura = usuario.documentos.find((doc) => doc.idNota === cell.row.values.idNota);
                          return (
                            <td
                              {...cell.getCellProps()}
                              className={"column100 d-flex flex-row" + cell.column.style}
                              data-label={`${cell.column.Header}: `}
                              key={"cell" + row.id + "-botaoDownload"}
                            >
                              <button
                                className="btn btn-primary btn-lg bot-modal-visualizar-pdf d-flex flex-row"
                                onClick={() => {
                                  if (fatura.tipo === "Nota Fiscal") handleDownloadNota(fatura.idNota);
                                  else {
                                    setFatura(fatura);
                                    navigate("/imprimeFatura");
                                  }
                                }}
                              >
                                <FaGlasses className="mt-1 me-2" />
                                Visualizar
                                {fatura.tipo === "Nota Fiscal" && <FaExternalLinkAlt className="mt-1 ms-2"/>}
                              </button>
                              <button
                                disabled={fatura.status!=="Nova"}
                                className="btn btn-primary btn-lg bot-modal-visualizar-pdf mx-2 px-2 d-flex flex-row"
                                onClick={() => handleCancelarNota(fatura.idNota)}
                              >
                                <FaBan className="mt-1 me-1" />
                                Cancelar
                              </button>
                              {fatura.anexo_Boleto && <button
                                className="btn btn-primary btn-lg bot-modal-visualizar-pdf d-flex flex-row"
                                style={{marginRight:"8px"}}
                                onClick={() => {
                                  handleDownloadBoleto(fatura.idNota);                                 
                                }}
                              >
                                <FaFileInvoiceDollar className="mt-1 me-2" />
                                Boleto                               
                              </button>}
                              {fatura.anexo_Carta && <button
                                className="btn btn-primary btn-lg bot-modal-visualizar-pdf d-flex flex-row"
                                onClick={() => {
                                  handleDownloadCarta(fatura.idNota);                                 
                                }}
                              >
                                <FaFileSignature className="mt-1 me-2" />
                                Carta                               
                              </button>}
                            </td>
                          );
                        })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
        <div className="bot_inserir d-flex flex-row">
          <div className="paginador col-8">
            <nav aria-label="Page navigation example" className="d-flex">
              <ul className="pagination justify-content-start">
                <Paginator />
              </ul>
              <span className="span-pagination ps-3">
                Exibindo {pageIndex * pageSize + 1} até {pageIndex * pageSize + page.length - 1 + 1} de {rows.length} linhas
              </span>
            </nav>
          </div>

          <div className="d-flex gap-2" style={{margin:"0 0 0 -5rem"}}>
            <div className="bot_inserir">
              <div className="paginador"></div>
              <div className="bot-inserir-btnew">
                <button
                  className="login100-form-btn btn-inserir-new"
                  onClick={() => {
                    const user = { ...usuario };
                    user.novoDocumento = undefined;
                    setUsuario(user);
                    navigate("/inserirDocumento");
                  }}
                >
                  INSERIR NOTA FISCAL / FATURA
                </button>
              </div>
            </div>
            <div className="bot_inserir">
              <div className="paginador"></div>
              <div className="bot-inserir-btnew">
                <button
                  className="login100-form-btn btn-inserir-new"
                  style={{backgroundColor:"#17a3b8", marginBottom:"1rem"}}
                  onClick={() =>  {
                    showModalAnexo(data);
                  }}
                >
                  INSERIR CARTA DE CORREÇÃO
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  function sortResults(data, prop, asc) {
    return data.sort(function (a, b) {
      if (asc) {
        return a[prop] > b[prop] ? 1 : a[prop] < b[prop] ? -1 : 0;
      } else {
        return b[prop] > a[prop] ? 1 : b[prop] < a[prop] ? -1 : 0;
      }
    });
  }
  const data = !usuario.documentos
    ? {}
    : sortResults(usuario.documentos, order, orderAsc)
        .filter(
          (record) =>
            record.idNota.toString().toUpperCase().includes(props.filter.toUpperCase()) ||
            record.tipo.toUpperCase().includes(props.filter.toUpperCase()) ||
            record.numeroNota.toUpperCase().includes(props.filter.toUpperCase()) ||
            record.dataInclusaoStr.toUpperCase().includes(props.filter.toUpperCase()) ||
            record.descricao.toUpperCase().includes(props.filter.toUpperCase()) ||
            record.tipo.toUpperCase().includes(props.filter.toUpperCase()) ||
            (record.statusFornecedor && record.statusFornecedor.toUpperCase().includes(props.filter.toUpperCase()))
        )
        .filter((record) => props.statusArray.includes(record.statusFornecedor))
        .filter((record) => props.tipoFilter === "" || props.tipoFilter === record.tipo);
  if (usuario.documentos === undefined || usuario.documentos.length === 0) {
    return (
      <div className="d-flex column justify-content-between m-4 pt-3">
        <h2>Nenhum documento encontrado</h2>
        <button
          className="login100-form-btn btn-inserir-new"
          onClick={() => {
            navigate("/inserirDocumento");
          }}
        >
          INSERIR NOTA FISCAL / FATURA
        </button>
      </div>
    );
  }
  return (
    <>
     
      <div className="wrap-table100">
        <div className="table100 ver1 m-b-20">
          <Table columns={columns} data={data} />
        </div>
      </div>  
    </>
  );
};

export default TabelaDocumentos;
